import { tns } from 'tiny-slider/src/tiny-slider';

class FeaturedWorkSlider {
	constructor(el, nav) {
		this.el = el;
		this.nav = nav;

		const featuredWorkSlider = tns({
			container: this.el,
			items: 1,
			slideBy: 1,
			mode: "gallery",
			autoplay: true,
			autoplayButtonOutput: false,
			speed: 400,
			controls: false,
			nav: true,
			navPosition: "bottom",
			navContainer: this.nav
		});

		return featuredWorkSlider;
		
	}
}

export default FeaturedWorkSlider;